import React from 'react';
import './Clients.css';
import devlabsLogo from '../assets/clients/devlabs.jpg';
import codeAspireLogo from '../assets/clients/CodeAspire.jpg';
import futureFocusLogo from '../assets/clients/FutureFocus.jpg';
import techuavaLogo from '../assets/clients/Techuava.jpg';
import techClickLogo from '../assets/clients/TechClick.jpg';

function Clients() {
  const clients = [
    {
      name: 'DevLabs',
      logo: devlabsLogo
    },
    {
      name: 'CodeAspire',
      logo: codeAspireLogo
    },
    {
      name: 'FutureFocus',
      logo: futureFocusLogo
    },
    {
      name: 'Techuva',
      logo: techuavaLogo
    },
    {
      name: 'TechClick',
      logo: techClickLogo
    }
  ];

  return (
    <section id="clients" className="clients">
      <div className="container">
        <h2 className="section-title">Our Clients</h2>
        <p className="section-subtitle">
          Trusted by leading companies worldwide
        </p>
        <div className="clients-grid">
          {clients.map((client, index) => (
            <div key={index} className="client-card">
              <div className="client-logo-wrapper">
                <img
                  src={client.logo}
                  alt={`${client.name} Logo`}
                  className="client-logo"
                />
              </div>
              <h3 className="client-name">{client.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Clients;
